import type { PayrollSettings } from '@/lib/types';

export const PAY_WEEK_DAY_NAMES = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
] as const;

export function payWeekStartDayName(day: number): string {
  return PAY_WEEK_DAY_NAMES[day] ?? PAY_WEEK_DAY_NAMES[0];
}

function trimNumber(value: string): string {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? String(parsed) : value;
}

/**
 * Plain-language overtime rule derived from PayrollSettings, e.g.
 * "1.5× after 40 h in a week starting Monday". This is what "Overtime: Auto"
 * means for a worker with no explicit overtime rate.
 */
export function describeOvertimeRule(
  settings: Pick<PayrollSettings, 'overtime_multiplier' | 'overtime_threshold_weekly' | 'pay_week_start_day'>,
): string {
  const multiplier = trimNumber(settings.overtime_multiplier);
  const threshold = trimNumber(settings.overtime_threshold_weekly);
  const day = payWeekStartDayName(settings.pay_week_start_day);
  return `${multiplier}× after ${threshold} h in a week starting ${day}`;
}
